import { Fragment, useCallback, useEffect } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ContentCardSkeleton from '../../../components/TrackCard/ContentCardSkeleton';
import LessonCardContainer from '../../../components/LessonCard/LessonCardContainer';
import TrackCardContainer from '../../../containers/TracksPage/TrackCardContainer';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../../constants/Tracking';
import styled, { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import ApiError from '../../../components/Errors/ApiError';
import { RecommendationsGrid } from '../';
import { useRecommendationsForTrack } from '..';
import SectionHeading from '../../../components/SectionHeading';
import { useTrack } from '../../tracks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobilePadded = styled.div.withConfig({
  displayName: "TrackRecommendations__MobilePadded",
  componentId: "sc-1n96l2c-0"
})(["margin-top:24px;padding-left:12px;padding-right:12px;", ""], mediaQuery('notTablet', css(["padding-left:30px;padding-right:30px;"])));
export const TrackRecommendations = ({
  trackId
}) => {
  useEffect(() => {
    UsageTracker.track('subpageView', {
      screen: SCREENS.TRACK,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      trackId
    });
  }, [trackId]);
  const {
    track,
    trackError,
    trackLoading
  } = useTrack(trackId);
  const {
    recommendationsForTrack,
    recommendationsForTrackLoading,
    recommendationsForTrackError
  } = useRecommendationsForTrack(trackId);
  const recommendations = recommendationsForTrack && recommendationsForTrack.recommendations || [];
  const trackRecommendedCardClick = useCallback((recommendation, index) => () => {
    const recommendationMetadata = recommendation.recommendationMetadata;
    UsageTracker.track('interaction', {
      action: 'track-end-recommendation-card-click',
      cardNumber: index + 1,
      lessonId: recommendation.recommendationType === 'LESSON' && recommendation.recommendationId,
      trackId: recommendation.recommendationType === 'TRACK' && recommendation.recommendationId,
      recommendationStrategy: recommendation.recommendationStrategy,
      preferredTopic: recommendationMetadata.preferredTopic,
      recommendedBecauseTrackId: recommendationMetadata.entityType && recommendationMetadata.entityType === 'TRACK' && recommendationMetadata.entityId,
      recommendedBecauseLessonId: recommendationMetadata.entityType && recommendationMetadata.entityType === 'LESSON' && recommendationMetadata.entityId
    });
  }, []);
  if (recommendationsForTrackError || trackError) {
    return /*#__PURE__*/_jsx(ApiError, {
      error: recommendationsForTrackError || trackError
    });
  }
  if ((!recommendationsForTrackLoading || !trackLoading) && !recommendations) {
    return null;
  }
  return /*#__PURE__*/_jsxs(MobilePadded, {
    "data-test-id": "track-recommendations-page",
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-bottom-6",
      children: /*#__PURE__*/_jsx(SectionHeading, {
        subText: track && /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.tracks.recommendations.body",
          options: {
            trackName: track.name
          }
        }),
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.tracks.recommendations.heading"
        })
      })
    }), /*#__PURE__*/_jsx(RecommendationsGrid, {
      children: recommendationsForTrackLoading || trackLoading ? /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {})]
      }) : recommendations.slice(0, 3).map((recommendation, index) => recommendation.recommendationType === 'LESSON' ? /*#__PURE__*/_jsx(LessonCardContainer, {
        appearsIn: "recommendations",
        lessonId: Number(recommendation.recommendationId),
        onClick: trackRecommendedCardClick(recommendation, index),
        position: index + 1
      }, recommendation.recommendationId) : /*#__PURE__*/_jsx(TrackCardContainer, {
        appearsIn: "recommendations",
        isUnfilterable: true,
        onClick: trackRecommendedCardClick(recommendation, index),
        position: index + 1,
        trackId: Number(recommendation.recommendationId)
      }, recommendation.recommendationId))
    })]
  });
};